<template>
    <div id="loan-status-dates">
        <div class="vx-row">
            <div class="vx-col w-full">
                <h6 class="bold success">
                    INFORMACIÓN BANCARIA
                </h6>
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <vs-table :data="bankAccounts">
                            <template slot="thead">
                                <vs-th class="bold" v-for="(col, idx) in columns" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <tbody>
                                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                        <vs-td>
                                            {{ tr.bank.short_name }}
                                        </vs-td>
                                        <vs-td>
                                            {{ tr.clabe }}
                                        </vs-td>
                                        <vs-td>
                                            {{ translateBankAccountStatus(tr.verified) }}
                                        </vs-td>
                                        <vs-td>
                                            {{ booleanFormat(tr.is_default) }}
                                        </vs-td>
                                    </vs-tr>
                                </tbody>
                            </template>
                        </vs-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dateHelper from '@mixins/dateHelper';
import formatHelper from '../../../../../components/mixins/formatHelper';

const columns = [
    { title: "BANCO", key: "bank", sortable: true },
    { title: "CLABE", key: "key", sortable: true },
    { title: "ESTADO", key: "status", sortable: true },
    { title: "¿ES FAVORITA?", key: "is_default", sortable: true }
];

export default {
    name: "BankAccountsDetail",
    mixins: [dateHelper, formatHelper],
    data: () => ({
        columns: columns
    }),
    props: {
        source: Object
    },
    computed: {
        isMoral() {
            return this.source.client.user.person_type == 0;
        },
        user_applicant() {
            return this.source.client.user;
        },
        applicant() {
            return this.source.client;
        },
        bankAccounts(){
            if(this.isMoral) {
                return this.user_applicant.business.bank_accounts;
            } else {
                return this.user_applicant.personal.bank_accounts;
            }
        }
    },
    methods: {
        translateBankAccountStatus(status)
        {
            let statusMap = {
                'unverified'            : "SIN VERIFICAR",
                'verified'              : "VERIFICADA",
                'verified_requested'    : "VERIFICACIÓN SOLICITADA",
                'rejected'              : "RECHAZADA",
                'cep_requested'         : "SOLICITUD CEP",
            };

            return statusMap[status]||"--";
        }
    }
}
</script>

<style>
#loan-status-dates .vx-card__body {
    padding: .5rem !important;
}
</style>